import { wordPath, type WordState } from './api'

export type NavigateOptions = {
  /** すでに取得済みの状態 (POST のレスポンスなど) */
  state?: WordState
  /** history.pushState するか。popstate からの復元では false */
  push?: boolean
}

export type ResolvedNavigateOptions = {
  state?: WordState
  push: boolean
}

export type NavigationHandler = (word: string, options: ResolvedNavigateOptions) => void

let handler: NavigationHandler | null = null

export function setNavigationHandler(next: NavigationHandler | null): void {
  handler = next
}

/**
 * 単語画面へ遷移する。
 * ハンドラが未登録 (= 差し替えられない状況) なら素の画面遷移にフォールバックする。
 */
export function navigate(word: string, options: NavigateOptions = {}): void {
  if (!handler) {
    location.assign(wordPath(word))
    return
  }
  handler(word, { state: options.state, push: options.push ?? true })
}
